export function defaultCardConnectSettings() {
    return {
        enabled: false,
        label: "",
        services: [],
        currency: "",
        site: "",
        port: "",
        merchid: "",
        username: "",
        password: "",
    };
}
//# sourceMappingURL=index.js.map